<header class="app-topbar">
  <div class="app-topbar__inner">
    <div class="app-topbar__start">
      <div class="app-topbar__toggle">
        <ng-content></ng-content>
      </div>
      <form [formGroup]="filterForm" class="app-topbar__search d-none d-sm-block">
        <i class="bi bi-search app-topbar__search-icon" aria-hidden="true"></i>
        <input
          type="text"
          matInput
          [matAutocomplete]="customer"
          class="app-topbar__search-input"
          id="customer"
          formControlName="customer"
          placeholder="Cerca cliente, per nome, cognome o ragione sociale..."
          [class.is-invalid]="filterForm.get('customer')?.invalid"
        />
        <mat-autocomplete #customer="matAutocomplete" [displayWith]="displayCustomerName" class="app-topbar__autocomplete">
          @for (option of filteredCustomers$ | async; track option) {
            <mat-option [value]="option">
              <div>
                {{ option.denomination }}
                @if (option.fiscalcode) {
                  <span> - {{ option.fiscalcode }}</span>
                }
                @if (option.vat) {
                  <span> - {{ option.vat }}</span>
                }
              </div>
            </mat-option>
          }
        </mat-autocomplete>
      </form>
    </div>

    <div class="app-topbar__end">
      <nav class="app-topbar__icons" aria-label="Azioni rapide">
        @if (assistantInHeader) {
          <button
            type="button"
            class="app-topbar__assistant"
            (click)="toggleAssistant()"
            [attr.aria-pressed]="assistantStore.shownFromHeader"
            [attr.aria-label]="assistantStore.shownFromHeader ? 'Nascondi assistente' : 'Apri assistente'"
          >
            <app-walley [size]="46" [decorative]="true" [ambient]="true" crop="head" />
          </button>
        }
        <button
          type="button"
          class="app-topbar__iconbtn"
          (click)="goToRoute('/home')"
          [class.app-topbar__iconbtn--active]="activeItem === 'home'"
          aria-label="Home"
        >
          <i class="bi" [ngClass]="activeItem === 'home' ? 'bi-house-fill' : 'bi-house'"></i>
        </button>
        <button
          type="button"
          class="app-topbar__iconbtn"
          (click)="goToRoute('/agenda/calendar')"
          [class.app-topbar__iconbtn--active]="activeItem === 'calendar'"
          aria-label="Agenda"
        >
          <i class="bi" [ngClass]="activeItem === 'calendar' ? 'bi-calendar-fill' : 'bi-calendar4'"></i>
        </button>
        <button
          type="button"
          class="app-topbar__iconbtn app-topbar__iconbtn--notify"
          [matMenuTriggerFor]="menuNotifications"
          aria-label="Notifiche"
        >
          <i class="bi" [ngClass]="unreadCount > 0 ? 'bi-bell-fill' : 'bi-bell'"></i>
          @if (unreadBadge) {
            <span class="app-topbar__notify-badge">{{ unreadBadge }}</span>
          }
        </button>
      </nav>

      <div class="app-topbar__divider"></div>

      <button type="button" class="app-topbar__user" [matMenuTriggerFor]="menuUser">
        <div class="app-topbar__user-text">
          <p class="app-topbar__nickname">{{ nickname$ | async }}</p>
          <p class="app-topbar__role">Utente</p>
        </div>
        <div class="app-topbar__avatar" aria-hidden="true">
          <i class="bi bi-person-fill"></i>
        </div>
      </button>
    </div>
  </div>
</header>

<mat-menu #menuNotifications="matMenu" panelClass="app-topbar__notify-menu">
  <ng-template matMenuContent>
    <div class="app-topbar__notify-head" (click)="$event.stopPropagation()">
      <span>Notifiche</span>
      <button type="button" class="btn btn-link btn-sm p-0" [disabled]="unreadCount === 0" (click)="markAllRead($event)">
        Leggi tutto
      </button>
    </div>
    <div class="app-topbar__notify-list" (scroll)="onNotificationsScroll($event)">
      @if (notificationsLoading && notifications.length === 0) {
        <div class="app-topbar__notify-empty">Caricamento...</div>
      } @else if (notifications.length === 0) {
        <div class="app-topbar__notify-empty">Nessuna notifica</div>
      } @else {
        @for (item of notifications; track item.id) {
          <button
            mat-menu-item
            class="app-topbar__notify-item"
            [class.app-topbar__notify-item--unread]="!item.read_at"
            (click)="openNotification(item)"
          >
            <span class="app-topbar__notify-meta">
              {{ item.created_at | date:'dd/MM/yyyy HH:mm' }}
              @if (item.area_label) {
                <span class="app-topbar__notify-area">{{ item.area_label }}</span>
              }
            </span>
            <span class="app-topbar__notify-body">{{ item.body }}</span>
          </button>
        }
        @if (notificationsLoadingMore) {
          <div class="app-topbar__notify-more">Caricamento...</div>
        }
      }
    </div>
  </ng-template>
</mat-menu>

<mat-menu #menuUser="matMenu">
  <ng-template matMenuContent>
    <button mat-menu-item class="a_clean" (click)="goToProfile()">
      <mat-icon>account_circle</mat-icon>
      <span>{{ nickname$ | async }}</span>
    </button>
    <button mat-menu-item (click)="logOut()" class="a_clean">
      <mat-icon>exit_to_app</mat-icon>
      <span>Log out</span>
    </button>
  </ng-template>
</mat-menu>
